import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { SET_GROUP_TYPE } from '@redux/constants/ActionTypes';
import Button from '@components/smartAdminUI/Button';
import FormikInputGroup from '@components/smartAdminUI/input/FormikInputGroup';

const AgentLookup = ({ fields, groupName, validateFigField }) => {
  const dispatch = useDispatch();
  const selectLoading = useSelector(state => state.agent.selectLoading);

  const agentFullNameField = useMemo(() => fields.find(field => field.FieldName.toUpperCase().includes('FULLNAME')), [fields]);
  const officeNameField = useMemo(() => fields.find(field => field.FieldName.toUpperCase().includes('OFFICENAME')), [fields]);

  const { setFieldValue } = useFormikContext();

  const agentSearchClicked = () => {
    dispatch({ type: SET_GROUP_TYPE, groupType: groupName });
  };

  const onAgentCleared = () => {
    if (fields) {
      fields.map(field => {
        setFieldValue(field.FieldName, '');
        return null;
      });
    }
  };

  return (
    <div className="form-row mb-3" id="ListOfficeKeyNumeric">
      <div className={groupName === 'OfficeManager' ? 'col-md-10' : 'col-md-5'}>
        <FormikInputGroup
          {...agentFullNameField}
          key={agentFullNameField?.RowID}
          validateFigField={validateFigField}
        />
      </div>
      {
        groupName !== 'OfficeManager' && (
          <div className="col-md-5">
            <FormikInputGroup
              {...officeNameField}
              key={officeNameField?.RowID}
              validateFigField={validateFigField}
            />
          </div>
        )
      }
      <div className="col-auto">
        <div className="form-group mt-4 mb-2">
          <Button
            name="btnLookupAgentClear"
            onClick={onAgentCleared}
            variant="primary"
            tooltipText="Clear Agent"
            disabled={selectLoading}
          >
            <i className="far fa-times" aria-hidden="true" />
          </Button>
          <span data-toggle="modal" data-target="#agentLookupModal">
            <Button
              name="btnLookupAgent"
              onClick={() => agentSearchClicked()}
              variant="primary"
              tooltipText="Agent Lookup"
              disabled={selectLoading}
            >
              <i className="fas fa-user-tie" aria-hidden="true" />
            </Button>
          </span>
        </div>
      </div>
    </div>
  );
};

AgentLookup.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape()),
  groupName: PropTypes.string,
  validateFigField: PropTypes.func.isRequired,
};

export default AgentLookup;
